module.exports = __webpack_public_path__ + "img/Logo_Completo_IBRACO.93ccc047.svg";